<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/vendor' }">供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应商详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">基础信息</h3>
      <ul>
        <li>
          <p v-if="form.type == 1">
            <label>供应商名称：</label><a>{{ form.vendor }}</a>
          </p>
          <p>
            <label>供应商类型：</label><a>{{ form.type == 1 ? '公司' : '个人' }}</a>
          </p>
          <p>
            <label>{{ form.type == 1 ? '联系人姓名' : '姓名' }}：</label><a>{{ form.name }}</a>
          </p>
          <p>
            <label>{{ form.type == 1 ? '公司地址' : '住址' }}：</label><a>{{ form.type == 1 ? form.work_address :
              form.family_address }}</a>
          </p>
          <p>
            <label>服务说明：</label><a>{{ form.info }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>联系人电话：</label><a>{{ form.phone }}</a>
          </p>
          <p>
            <label>联系人邮箱：</label><a>{{ form.email }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">付款信息</h3>
      <ul>
        <li>
          <p>
            <label>税率：</label><a>{{ form.rate ? `${form.rate}%` : '暂无' }}</a>
          </p>
          <p>
            <label>付款账户：</label><a>{{ form.payee_name }}</a>
          </p>
          <p>
            <label>银行名称：</label><a>{{ form.payee_bank }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(form.payee_bank_account)">{{
              form.payee_bank_account }}</a>
          </p>
        </li>
        <li>

        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle" v-if="form.type == 1">工商信息</h3>
      <ul>
        <li>
          <p v-if="form.type == 1">
            <label>统一社会信用代码：</label><a>{{ form.company_id_card }}</a>
          </p>
          <p v-if="form.type == 1">
            <label>公司注册地址：</label><a>{{ form.reg_address }}</a>
          </p>
          <p v-if="form.type == 1">
            <label>公司电话：</label><a>{{ form.company_phone }}</a>
          </p>
          <p>
            <label>附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(item, index) in fileList" :key="index">
                  <el-col :span="24" v-if="item.origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ item.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                        target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>

        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">所有刊例</h3>
      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <!-- <el-table-column prop="vendor_name" label="供应商名称" header-align="center" align="center" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.vendor_name }}
          </template>
        </el-table-column> -->
        <el-table-column prop="category" label="类型" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">
            <el-cascader ref="cateIdArray" v-model="scope.row.cate_id_array" :options="selectTypeList"
              :props="{ expandTrigger: 'hover', checkStrictly: false }" @blur="handleEdit(scope, 'cateIdArray')"
              @change="v => changeData(v, scope, 'cateIdArray')" v-if="scope.row.cateIdArrayFlag"></el-cascader>
            <div class="inner" v-else @click="handleScopeChange(scope, 'cateIdArray')">{{
              getCascaderValues(scope.row.cate_id_array, selectTypeList) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="card_desc" label="描述" header-align="center" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input ref="cardDesc" type="textarea" v-model="scope.row.card_desc" spellcheck="false"
              :autosize="{ minRows: 4 }" placeholder="请输入内容" @blur="handleEdit(scope, 'cardDesc')"
              @change="v => changeData(v, scope, 'cardDesc')" v-if="scope.row.cardDescFlag"></el-input>
            <div class="inner" v-else @click="handleScopeChange(scope, 'cardDesc')">{{ scope.row.card_desc }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="单价（元）" header-align="center" align="center" min-width="80">
          <template slot-scope="scope">
            <el-input ref="vPrice" @input="_limitInput" placeholder="请输入" maxlength="100" v-model="scope.row.price"
              clearable @blur="handleEdit(scope, 'vPrice')" @change="v => changeData(v, scope, 'vPrice')"
              v-if="scope.row.vPriceFlag" />
            <div class="inner" v-else @click="handleScopeChange(scope, 'vPrice')">{{ scope.row.price }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位" header-align="center" align="center" min-width="80">
          <template slot-scope="scope">
            <el-select ref="vUnit" placeholder="请选择" v-model="scope.row.unit" @blur="handleEdit(scope, 'vUnit')"
              @change="v => changeData(v, scope, 'vUnit')" filterable v-if="scope.row.vUnitFlag">
              <el-option :label="v.unit" :value="v.unit" v-for="(v, i) in unitList" :key="`unit_${i}`"></el-option>
            </el-select>
            <div class="inner" v-else @click="handleScopeChange(scope, 'vUnit')">{{ scope.row.unit }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="card_remarks" label="备注" header-align="center" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input ref="cardRemarks" type="textarea" v-model="scope.row.card_remarks" spellcheck="false"
              :autosize="{ minRows: 4 }" placeholder="请输入内容" @blur="handleEdit(scope, 'cardRemarks')"
              @change="v => changeData(v, scope, 'cardRemarks')" v-if="scope.row.cardRemarksFlag"></el-input>
            <div class="inner" v-else @click="handleScopeChange(scope, 'cardRemarks')">{{ scope.row.card_remarks }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" header-align="center" align="center" width="150" fixed="right" v-if="NodeInclude('424') || NodeInclude('425')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="showDelete(scope)" v-if="NodeInclude('424')"><i class="el-icon-delete"></i>删除</el-link>
              <el-link type='primary' class="link" @click="viewClick(scope.row)" v-if="NodeInclude('425')">查看同类型</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="add">
        <el-button @click="addFn" v-if="NodeInclude('418')"><i class="el-icon-circle-plus" style="margin-right: 10px;"></i>新增明细</el-button>
        <el-button type="primary" @click="addUpdateVendorCard" v-if="NodeInclude('418')">保存全部修改</el-button>
      </div>
    </div>

    <el-dialog title="删除" :visible.sync="deleteShow" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>是否确认删除</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDelete()">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from "@/api";
import store from '@/store'
import { thousands, antiThousands, limitInput } from "@/utils/index.js";
export default {
  name: "vendorview",
  data() {
    return {
      nodeLimtList: [],
      form: {
        type: "1",
        vendor_id: "",
        vendor: "",
        id_card: "",
        work_address: "",
        family_address: "",
        name: "",
        phone: "",
        email: "",
        info: "",
        rate: "",
        payee_name: "",
        payee_bank: "",
        payee_bank_account: "",
        company_id_card: "",
        reg_address: "",
        company_phone: "",
        atta_str: {},
      },
      itemList: [],
      total: 0,
      p: 1,
      perPage: 30,
      rules: {},
      fileList: [
        {
          origin_name: "",
          file_name: "",
          httpFile: "",
          file_id: "",
          flist: [],
        },
      ],
      unitList: [],
      selectTypeList: [],
      deleteShow: false,
      deleteForm: {
        index: '',
      },
      del_detail_list: [],
    };
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query;
    this.query.id &&
      this.initFn().then(() => {
        this.getDetail(this.query.id);
      });
  },
  mounted() { },
  watch: {
    ["form.payee_bank_account"](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.payee_bank_account = val
            .replace(/\D/g, "")
            .replace(/....(?!$)/g, "$& ");
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分
      const hash = window.location.hash;
      // 移除'#'字符
      const url = hash.substring(1);
      let postData = {
        url_path: url,
      };
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: "info",
            message: "暂无权限",
          });
          this.$router.push({
            path: `/home`,
          });
        }
      });
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      };
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(",");
      });
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val);
    },
    getSelectType() {
      this.$fly.post("ApiVendorCard_selectTypeList.html", {}).then((res) => {
        this.selectTypeList = res.length ? res : [];
      });
    },
    getUnitList() {
      this.$fly.post("ApiVendorCard_selectUnit.html", {}).then((res) => {
        const cardUnitArray = [];
        for (const value of Object.entries(res)) {
          cardUnitArray.push({
            [`val`]: value[0],
            [`unit`]: value[1],
          });
        }
        this.unitList = cardUnitArray;
      });
    },
    initFn() {
      return new Promise((resolve) => {
        this.getSelectType();
        this.getUnitList();
        resolve("success");
      });
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post("apiPurchase_getVendorDetail.html", {
          vendor_id: id,
        })
        .then((res) => {
          let form = res.itemArr;
          this.itemList = res.itemArr.cardList.map((item) => {
            item.price = thousands(Number(item.price));
            item.vPriceFlag = false;
            item.vUnitFlag = false;
            item.cardRemarksFlag = false;
            item.cardDescFlag = false;
            item.cateIdArrayFlag = false;
            item.cate_id_array = item.cateInfo.cate_id_json ? JSON.parse(item.cateInfo.cate_id_json) : []
            return item;
          });
          this.fileList = res.itemArr.fileList.map((item) => {
            delete item.client_id;
            delete item.create_time;
            item.flist = [];
            return item;
          });
          //防空情况
          if (this.fileList.length === 0) {
            this.fileList = [
              {
                origin_name: "",
                file_name: "",
                httpFile: "",
                id: "",
                flist: [],
              },
            ];
          }
          delete this.form.cardList
          return (this.form = form);
        });
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData("text/plain", msg.replace(/\s*/g, ""));
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true,
      };
      document.addEventListener("copy", save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand("copy"); // 执行copy方法
      this.$message({ message: "复制成功", type: "success" });
    },
    handleCurrentChange(p) {
      this.p = p;
      this.query.id && this.getDetail(this.query.id);
    },
    handleScopeChange({ row }, ref) {
      //显示文本框
      //重置表格所有的输入框
      this.itemList = this.itemList.map((item) => {
        item.vPriceFlag = false;
        item.vUnitFlag = false;
        item.cardRemarksFlag = false;
        item.cardDescFlag = false;
        item.cateIdArrayFlag = false;
        return item;
      });
      //打开当前修改输入框
      this.$set(row, `${ref}Flag`, true);
      if (ref != "file" && ref != "cateIdArray") {
        this.$nextTick(() => {
          this.$refs[ref].focus(); //显示文本框并获取焦点
        });
      }
    },
    handleEdit({ row }, ref) {
      //隐藏文本框
      setTimeout(() => {
        this.$set(row, `${ref}Flag`, false);
      }, 100); // 延迟 100ms 执行
    },
    changeData(value, { row, column }, ref) {
      //该方法调用修改的接口进行修改
      if (column.label == "单价（元）") {
        let temp = this._limitInput(value);
        row.price = thousands(Number(temp));
      }
      if (column.label  == "类型") {
        const trueId = value[value.length - 1]
        row.cate_id = trueId
        console.log(row.cate_id);
      }
      this.$set(row, `${ref}Flag`, false);
    },
    _limitInput(v) {
      return limitInput(v);
    },
    //用来取List里val值为targetVal的值
    // getCardUnitValue(list, targetVal) {
    //   const target = list.find(item => item.val === targetVal);
    //   return target ? target.unit : '';
    // },
    //用来取escader的值
    getCascaderValues(cate_id_array, options) {
      // try { } catch (error) { console.error('解析 JSON 失败:', error); return []; }
      const ids = cate_id_array;
      const result = [];
      let currentOptions = options;
      for (const id of ids) {
        const found = currentOptions.find(option => option.value === id);
        if (found) {
          result.push(found.label);
          if (found.children) {
            currentOptions = found.children;
          }
        } else {
          break;
        }
      }
      return result.join('/');
    },
    //点击添加
    addFn() {
      const item = { id: '0', cate_id: '', vendor_name: this.form.vendor, cate_id_array: [], card_desc: '', price: '', unit: '', card_remarks: '', vPriceFlag: false, vUnitFlag: false, cardRemarksFlag: false, cardDescFlag: false, cateIdArrayFlag: false, }
      this.itemList.push(item)
      this.$forceUpdate()
    },
    showDelete({ row }) {
      const index = this.itemList.indexOf(row)
      this.deleteForm.index = index
      this.deleteShow = true
    },
    //点击删除
    handleDelete() {
      const _index = this.deleteForm.index
      console.log(_index);
      this.del_detail_list.push(this.itemList[_index].id);
      this.itemList.splice(_index, 1)
      this.deleteShow = false
      this.addUpdateVendorCard()
    },
    viewClick(item) {
      const form = {
        cate_id_array: JSON.parse(item.cateInfo.cate_id_json),
        cate_id: item.cateInfo.id
      }
      store.commit('setPubcaseData', JSON.parse(JSON.stringify(form)))
      this.$router.push({
        path: '/pubcase',
        query: {  },
      })
    },
    addUpdateVendorCard() {
      const $itemList = this.itemList.map((item) => {
        const { cate_id, card_desc, unit, price, card_remarks, id } = item;
        return { cate_id, card_desc, unit, price: antiThousands(price), card_remarks, card_id: id };
      })
      this.$fly
        .post('/ApiVendorCard_addOrUpdateVendorCard.html', {
          vendor_id: this.query.id,
          card_str: JSON.stringify($itemList),
          del_str: this.del_detail_list.toString(),
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
            this.del_str = ''
            this.query.id && this.initFn().then(() => { this.getDetail(this.query.id); });
          }
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 20px 40px;

    ul {
      padding: 0 25px 0 25px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-flow: row nowrap;
      color: var(--text-1); /* 0819修改 */;
      border-radius: 20px;
      background: var(--bg-soft); /* 0819修改 */
      margin-bottom: 20px;
      position: relative;

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          a {
            cursor: default;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }
      }
    }
  }

  .inner {
    display: block;
    min-height: 23px;

    span {
      margin-right: 10px;
      font-size: 12px;
      display: inline-block;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;

      &.a-remind {
        font-size: 16px;
        cursor: pointer;
      }
    }
  }

  .add {
    padding: 20px 0 0;
  }

}
</style>
